<app-form-supervbase
    [groupList]="groupList"
    [userList]="userList"
    [basketList]="basketList"    
    (onValidate)="validate($event)"
    (onCancel)="cancel()"
>
</app-form-supervbase>

